"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.machineJSON = exports.createAppointmentCancelMachine = void 0;
var _xstate = require("xstate");
var _moment = _interopRequireDefault(require("moment"));
var _xstate2 = require("../../lib/constants/xstate");
var _API = require("../../lib/API");
var _utils = require("../../lib/utils");
var _getInitialContext = _interopRequireDefault(require("../getInitialContext"));
const APPOINTMENT_CANCELED_VALUE = 'canceled';

/**
 * Creates and returns the machine that orchestrates the appointment-cancel component.
 * @param {object} initialContext the initial context of the machine
 * @returns xstate.Machine
 */
const createAppointmentCancelMachine = function () {
  let initialContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _getInitialContext.default)();
  return (0, _xstate.Machine)(machineJSON(initialContext), {
    actions: {
      [_xstate2.actions.setAppointment]: (0, _xstate.assign)({
        appointment: (_context, event) => {
          return event.data.appointment;
        },
        locationId: (_context, event) => {
          return event.data.locationId;
        },
        providerId: (_context, event) => {
          return event.data.providerId;
        }
      }),
      [_xstate2.actions.setProvider]: (0, _xstate.assign)({
        provider: (_context, event) => {
          return event.data.provider;
        },
        locations: (_context, event) => {
          return event.data.locations;
        }
      }),
      [_xstate2.actions.setCancelParameters]: (0, _xstate.assign)({
        cancelEmailConsent: (_context, event) => {
          return event.data.cancelEmailConsent;
        },
        cancelReasonText: (_context, event) => {
          return event.data.cancelReasonText;
        }
      })
    },
    guards: {
      [_xstate2.guards.hasAppointment]: context => {
        return !!context.appointment;
      },
      [_xstate2.guards.isAppointmentCanceled]: context => {
        return context.appointment.status === APPOINTMENT_CANCELED_VALUE;
      },
      [_xstate2.guards.isCancelationDisabled]: context => {
        return !context.appointment.isCancelEnabled;
      },
      [_xstate2.guards.isCancelationExpired]: context => {
        return !!(0, _moment.default)(context.appointment.latestCancellation).isBefore((0, _moment.default)());
      },
      [_xstate2.guards.shouldSkipProvider]: context => {
        return !context.services.getProvider;
      },
      [_xstate2.guards.wasNotInitializedWithAppointmentData]: context => {
        return !context.appointment && !context.appointmentId;
      }
    },
    services: {
      [_xstate2.services.getAppointment]: async context => {
        return (0, _API.getAppointmentById)(context.services.getAppointment, context.appointmentId);
      },
      [_xstate2.services.getProvider]: async context => {
        return (0, _API.getProviderById)(context.services.getProvider, context.providerId);
      },
      [_xstate2.services.deleteAppointment]: async context => {
        return (0, _API.cancelAppointmentById)(context.services.cancelAppointment, context.appointmentId, context.cancelEmailConsent, context.cancelReasonText);
      }
    }
  });
};

/**
 * Returns the machine JSON for appointment-cancel. Exported to facilitate testing.
 * @param {object} initialContext the initial context for the machine
 * @returns object
 */
exports.createAppointmentCancelMachine = createAppointmentCancelMachine;
const machineJSON = function () {
  let initialContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _getInitialContext.default)();
  return {
    id: 'appointment-cancel',
    initial: _xstate2.states.initializing,
    context: {
      ...initialContext,
      ...(0, _utils.convertAppointment)(initialContext.appointment)
    },
    states: {
      [_xstate2.states.initializing]: {
        on: {
          [_xstate2.events.initialized]: {
            target: _xstate2.states.appointment
          }
        }
      },
      [_xstate2.states.appointment]: {
        initial: _xstate2.states.routing,
        states: {
          [_xstate2.states.routing]: {
            always: [{
              cond: _xstate2.guards.wasNotInitializedWithAppointmentData,
              target: _xstate2.states.error
            }, {
              cond: _xstate2.guards.hasAppointment,
              target: _xstate2.states.success
            }, {
              target: _xstate2.states.pending
            }]
          },
          [_xstate2.states.pending]: {
            invoke: {
              id: 'getAppointment',
              src: _xstate2.services.getAppointment,
              onDone: {
                actions: _xstate2.actions.setAppointment,
                target: _xstate2.states.success
              },
              onError: {
                target: _xstate2.states.error
              }
            }
          },
          [_xstate2.states.success]: {
            type: 'final'
          },
          [_xstate2.states.error]: {
            // Dead end
          }
        },
        onDone: {
          target: _xstate2.states.provider
        }
      },
      [_xstate2.states.provider]: {
        initial: _xstate2.states.routing,
        states: {
          [_xstate2.states.routing]: {
            always: [{
              cond: _xstate2.guards.shouldSkipProvider,
              target: _xstate2.states.success
            }, {
              target: _xstate2.states.pending
            }]
          },
          [_xstate2.states.pending]: {
            invoke: {
              id: 'getProvider',
              src: _xstate2.services.getProvider,
              onDone: {
                actions: _xstate2.actions.setProvider,
                target: _xstate2.states.success
              },
              onError: {
                // Should target loadingProviderError, current designs are all or nothing
                target: _xstate2.states.error
              }
            }
          },
          [_xstate2.states.success]: {
            type: 'final'
          },
          [_xstate2.states.error]: {
            // Dead end
          }
        },
        onDone: [{
          cond: _xstate2.guards.isAppointmentCanceled,
          target: _xstate2.states.canceledPreviously
        }, {
          cond: _xstate2.guards.isCancelationDisabled,
          target: _xstate2.states.cancelDisabled
        }, {
          target: _xstate2.states.cancelPage
        }]
      },
      [_xstate2.states.cancelDisabled]: {
        initial: _xstate2.states.routing,
        states: {
          [_xstate2.states.routing]: {
            always: [{
              cond: _xstate2.guards.isCancelationExpired,
              target: _xstate2.states.cancelExpiredPage
            }, {
              target: _xstate2.states.cancelDisabledPage
            }]
          },
          [_xstate2.states.cancelDisabledPage]: {
            // Dead end
          },
          [_xstate2.states.cancelExpiredPage]: {
            // Dead end
          }
        }
      },
      [_xstate2.states.canceledPreviously]: {
        // Dead end
      },
      [_xstate2.states.cancelPage]: {
        initial: _xstate2.states.appointmentCancel,
        states: {
          [_xstate2.states.appointmentCancel]: {
            on: {
              [_xstate2.events.cancel]: {
                target: _xstate2.states.cancelingAppointment,
                actions: _xstate2.actions.setCancelParameters
              }
            }
          },
          [_xstate2.states.cancelingAppointment]: {
            invoke: {
              id: 'deleteAppointment',
              src: _xstate2.services.deleteAppointment,
              onDone: {
                target: _xstate2.states.cancelFinished
              },
              onError: {
                target: _xstate2.states.cancelError
              }
            }
          },
          [_xstate2.states.cancelError]: {
            // Dead end
          },
          [_xstate2.states.cancelFinished]: {
            type: 'final'
          }
        },
        onDone: {
          target: _xstate2.states.confirmationPage
        }
      },
      [_xstate2.states.confirmationPage]: {
        type: 'final'
      }
    }
  };
};
exports.machineJSON = machineJSON;